import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { toggleClass } from 'react-classlist-helper'
import { RouteComponentProps, withRouter } from 'react-router'

import MobileInitialState from '~/client/src/mobile/stores/MobileInitialState'
import MobileCommonStore from '~/client/src/mobile/stores/ui/MobileCommon.store'
import {
  Content,
  Footer,
  Header,
  View,
} from '~/client/src/shared/components/Layout'
import ActionBar from '~/client/src/shared/components/PhotoDetails/components/ActionBar/ActionBar'
import CommentsList from '~/client/src/shared/components/PhotoDetails/components/CommentsList/CommentsList'
import ImageContainer from '~/client/src/shared/components/PhotoDetails/components/ImageContainer/ImageContainer'
import LandscapeImage from '~/client/src/shared/components/PhotoDetails/components/LandscapeImage/LandscapeImage'
import PhotoDetailsBase from '~/client/src/shared/components/PhotoDetails/PhotoDetails'

import MobileDetailsHeader from '../DetailsHeader/MobileDetailsHeader'
import MobileFileInput from '../FileInput/MobileFileInput'

interface IProps {
  common?: MobileCommonStore
  state?: MobileInitialState
  match?: any
  photoId?: string
}

@inject('common', 'state')
@observer
class MobilePhotoDetails extends PhotoDetailsBase<
  IProps & RouteComponentProps
> {
  public componentDidMount() {
    const { common } = this.props

    if (!common.shouldHideNavBar) {
      common.toggleNavBar()
    }

    if (window.innerWidth > window.innerHeight) {
      this.isPortrait = false
    }

    window.addEventListener('orientationchange', this.handleLayout)
  }

  public componentWillUnmount() {
    window.removeEventListener('orientationchange', this.handleLayout)
  }

  public render() {
    const photo = this.photo
    const caption = this.caption

    if (!photo || !caption) {
      return (
        <div className="activity-details-view">
          <div className="text bold large center pa20 bg-light-cool-grey">
            Loading...
          </div>
        </div>
      )
    }
    const { userActiveProjectSettings } = this.props.state

    if (this.isPortrait) {
      return (
        <View>
          <Header>
            <MobileDetailsHeader
              caption={`Photo: ${caption.text}`}
              backClicked={this.backClicked}
            />
          </Header>
          <Content scrollable={true}>
            <div className="activity-log">
              <ImageContainer src={photo.url} />
              <CommentsList
                photo={photo}
                showFooterLine={true}
                FileInputType={MobileFileInput}
              />
            </div>
          </Content>
          <Footer
            className={toggleClass(
              'inactive-element',
              userActiveProjectSettings?.isPresentationUser,
            )}
          >
            <ActionBar photo={photo} />
          </Footer>
        </View>
      )
    } else {
      return (
        <View>
          <LandscapeImage src={photo.url} />
        </View>
      )
    }
  }

  public backClicked = () => {
    this.props.common.history.goBack()
  }
}

export default withRouter(MobilePhotoDetails)
